module.exports = __webpack_public_path__ + "images/emoji/panda_face.8e05baa4a2f975d0ee67.png";